import { createNextTableContext } from '@shared/modules/next-table/context/context';

export const DnsQueuesTableContext = createNextTableContext();
export const CustomsDeclarationsTableContext = createNextTableContext();
export const CustomsPostsTableContext = createNextTableContext();
export const CustomsTasksTableContext = createNextTableContext();
